import React from "react";
function ChatHint() {
  return(
    <div id="bot-scene-container">
    <div id="bot-scene-content" className="scroll-light">
      <div className="hint-intro">
        <div className="wrapper">
          <div className="left">
            <label>Gợi ý chat cho nhân viên tư vấn</label>
            <p>
              Giúp tăng tỷ lệ chốt đơn và cải thiện hiệu suất làm việc
              <br /> với chức năng Gợi ý chat.
            </p>
            <p>
              Là giải pháp hỗ trợ nhân viên khai thác thông tin cần thiết, giúp
              cửa hàng xây dựng mối quan hệ tốt hơn với khách hàng, từ đó thúc
              đẩy tỷ lệ chốt đơn thành công và bán lại
              <br />
              sản phẩm mới trong tương lai.
            </p>
            <p>
              Xem thêm hướng dẫn chi tiết{" "}
              <a
                href=""
                className="app-btn app-btn-link app-btn-pd-none"
                target="_blank"
              >
                tại đây
              </a>
              .
            </p>
            <div className="action">
              <button type="button" className="app-btn app-btn-primary">
                Khám phá gợi ý
              </button>
            </div>
          </div>
          <div className="right">
            <img src="/assets/images/hint_promote.svg" alt="Promotional Hint" />
          </div>
        </div>
      </div>
    </div>
  </div>
  );
  
}
export default ChatHint;
